module.exports = __webpack_public_path__ + "img/default.dff9de54.png";